<div class="youtube-player-container">
  <youtube-player
    [videoId]="getVideoId()"
    [style]="{ overflow:'hidden' }"

    placeholderImageQuality="high"
    [startSeconds]="startSeconds"
    [suggestedQuality]="'highres'"
    [playerVars]="{ autoplay: autoplay ? 1 : 0, modestbranding: 1 }"
  ></youtube-player>
</div>
